import { createRouter, createWebHistory } from 'vue-router'

import { useAffiliateManagerMediaStore } from '@/store/MediaAssetsStore'
import { updateParent } from '@/util/updateParent'
import { useAffiliateManagerStore } from './../store/index'

const routes = [
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager',
    name: 'onboarding',
    component: () => import('../pages/InitialisedManager.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/dashboard',
    name: 'dashboard',
    component: () => import('../pages/dashboard/index.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/campaigns',
    name: 'Home',
    component: () => import('../pages/Home.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/campaigns/create',
    name: 'CampaignCreate',
    component: () => import('../pages/campaign/CreateV3.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/campaigns/v3',
    name: 'CampaignCreateV3',
    component: () => import('../pages/campaign/CreateV3.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/campaigns/:id',
    name: 'CampaignEdit',
    component: () => import('../pages/campaign/EditV3.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/campaigns/:id/integration',
    name: 'CampaignIntegration',
    component: () => import('../pages/campaign/Integration.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/affiliates',
    name: 'affiliate',
    component: () => import('../pages/affiliates/AffiliatesIndex.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/affiliates/:id',
    name: 'affiliate-details',
    component: () => import('../pages/affiliates/detailsV2.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/payouts',
    name: 'payouts',
    component: () => import('../pages/payouts/index.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/media',
    name: 'media',
    component: () => import('../pages/media-assets/MediaAssetsIndex.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/media/folder/:folderId',
    name: 'NestedMedia',
    component: () => import('../pages/media-assets/MediaAssetsIndex.vue'),
  },

  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/settings',
    name: 'settings',
    component: () => import('../pages/settings/index.vue'),
  },
  {
    path: '/v2/location/:locationId/marketing/affiliate-manager/importer',
    name: 'importer',
    component: () => import('../pages/firstpromoter-importer/index.vue'),
  },
]
const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.afterEach(to => {
  const store = useAffiliateManagerStore()
  const { emptyDirectory } = useAffiliateManagerMediaStore()
  try {
    if (to?.name === 'media') {
      emptyDirectory()
    }
    if (
      to?.name === 'CampaignCreate' ||
      to?.name === 'CampaignCreateV3' ||
      to?.name === 'CampaignEdit' ||
      to?.name == 'CampaignIntegration' ||
      to?.name === 'importer'
    ) {
      store.updateFullScreen(true)
    } else {
      if (store.showFullScreen) store.updateFullScreen(false)
    }
    if (store.changeRoute) {
      store.setChangeRouteFlag(false)
    } else if (store.appHandshake) {
      store.appHandshake.then(parent => {
        parent.emit('spm-ts', {
          router: to.fullPath,
        })
      })
    }
  } catch (error) {
    // Error handling - silently catch errors
  }
})

// Export a function to setup the guard
export function setupRouterGuard(store: any) {
  router.beforeEach((to, from, next) => {
    const requiresInitialised = [
      'dashboard',
      'Home',
      'CampaignCreate',
      'CampaignEdit',
      'CampaignIntegration',
      'affiliate',
      'affiliate-details',
      'payouts',
    ].includes(to.name as string)

    const isOnboarding = store.skipOnboarding

    if (requiresInitialised && !isOnboarding) {
      updateParent('redirect-to-onboarding', {
        locationId: to.params.locationId,
      })
      return next({
        name: 'onboarding',
        params: { locationId: to.params.locationId },
      })
    }

    if (to.name === 'onboarding' && isOnboarding) {
      return next({
        name: 'dashboard',
        params: { locationId: to.params.locationId },
      })
    }

    return next()
  })
}

export default router
